import { useState, useLayoutEffect, useRef, RefObject } from 'react'

function useDetectTextOverflow<T extends HTMLElement = HTMLDivElement>(): {
  ref: RefObject<T>
  isOverflowing: boolean
} {
  const ref = useRef<T>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useLayoutEffect(() => {
    function updateOverflow() {
      const offsetWidth = ref.current?.offsetWidth || 0
      const scrollWidth = ref.current?.scrollWidth || 0
      setIsOverflowing(offsetWidth < scrollWidth)
    }

    window.addEventListener('resize', updateOverflow)
    updateOverflow()

    return () => window.removeEventListener('resize', updateOverflow)
  }, [])

  return { ref, isOverflowing }
}

export default useDetectTextOverflow
